import {Component} from '@angular/core';

@Component({
    selector: 'tfl-outgoing-5-transfer-icon',
    template: require('./outgoing-4.html')
})
export class Outgoing4TransferIcon {

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/outgoing/outgoing.4.transfer.icon.ts